import React, { useCallback, useState } from 'react';
import { ButtonPrimary } from '@americanexpress/dls-react';

import { AccountModel } from 'src/types/account.model';
import OnbordingProgress from 'src/components/atomic/molecules/onboardingProgress/OnboardingProgress';
import Drawer from 'src/components/drawer/Drawer';

import AddAccountViewTemplate from '../../addAccounts/AddAccountViewTemplate';
import AccountService from 'src/services/account.service';
import AccountsList from '../../../atoms/accountsList/AccountsList';
import AddAccountList from '../../../atoms/addAccountList/AddAccountList';
import { ListAccountsViewTemplateViewModel } from 'src/types/view-models/listAccounts/listAccountsViewModel.view.model';
import { ManualAccount, ManualAccountType } from 'src/types/manualAccount.model';
import LiteralsService from 'src/services/literals/LiteralsService';
import Selectors from 'src/utils/selectors';

export default function ListAccountsViewTemplate({
    progressIndex,
    accountDrawerType,
    title,
    listAccountsHeading,
    ManualAccountType,
    nonDrawerTypeAccounts,
    visibleAccounts,
    hiddenAccounts,
    extraAccountsInfo,
    investmentHoldings,
    debts,
    addAccountListTemplate,
    callout,
    formCallout,
    refreshAccounts,
    back,
    next,
    handleReloadUser,
    ...props
}: ListAccountsViewTemplateViewModel): JSX.Element {
    const [initialType, setInitialType] = useState<ManualAccountType>(); // navigate to create account
    const [editManualAccount, setEditManualAccount] = useState<ManualAccount>(); // navigate to edit account

    const handleBack: () => void = useCallback(() => {
        setInitialType(undefined);
        setEditManualAccount(undefined);
        void refreshAccounts();
    }, []);

    const onSubmitCallback: () => Promise<void> = useCallback(async () => {
        await handleReloadUser();
        handleBack();
    }, []);

    if (initialType || editManualAccount)
        return (
            <AddAccountViewTemplate
                title={title}
                accountTypes={ManualAccountType}
                initialType={initialType}
                editManualAccount={editManualAccount}
                callout={formCallout}
                onSubmitCallback={onSubmitCallback}
                handleBack={handleBack}
            />
        );

    return (
        <Drawer
            title={title}
            drawerProps={{ history }}
            withBackButton
            handleBack={() => {
                void back();
            }}
            {...props}
        >
            <OnbordingProgress index={progressIndex} length={7} />

            {visibleAccounts.length + hiddenAccounts.length + investmentHoldings.length + debts.length > 0 && (
                <AccountsList
                    withTotal
                    heading={listAccountsHeading}
                    accountDrawerType={accountDrawerType}
                    accounts={[
                        ...visibleAccounts,
                        ...hiddenAccounts.map((account: AccountModel) => {
                            account.hidden = true;
                            return account;
                        })
                    ]}
                    nonDrawerTypeAccounts={nonDrawerTypeAccounts}
                    investmentHoldings={investmentHoldings}
                    debts={debts}
                    manualOnClick={(manualAccount: ManualAccount) => {
                        setEditManualAccount(manualAccount);
                    }}
                    toggleOnClick={async (account: AccountModel, hidden: boolean) => {
                        if (hidden) await AccountService.showAccount(account.accountId);
                        else await AccountService.hideAccount(account.id);
                        await handleReloadUser();
                    }}
                />
            )}

            <AddAccountList
                list={addAccountListTemplate.map((e) => {
                    return {
                        title: e.title,
                        subtitle: e.subtitle,
                        onClick: () => setInitialType(e.manualAccountType)
                    };
                })}
            />

            {callout}

            <div>
                <ButtonPrimary onClick={next} data-cy={Selectors.PlanAhead.NEXT_BUTTON}>
                    {LiteralsService.getLiteral('Onboarding.next')}
                </ButtonPrimary>
            </div>
        </Drawer>
    );
}
